import axios from "axios";
import { AUTH_CREDS_KEY, clearAuthSession, getSecureItem, isTokenExpired } from "utils/security";

const rawBaseUrl = process.env.REACT_APP_BASE_URL || 'https://guidesantai.com/';
export const base_url = rawBaseUrl.endsWith('/') ? rawBaseUrl : `${rawBaseUrl}/`;

// Interceptor to handle automatic session purge on authentication failure (401/403)
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            console.warn('Authentication expired or unauthorized. Clearing session.');
            clearAuthSession();
        }
        return Promise.reject(error);
    }
);

export function getUrl(param: any) {
    return `${base_url}${param}`;
}

export async function get(url: any) {
    try {
        var req = await axios.get(base_url + url);
        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}

export async function pubJsonGet(data: any) {
    try {

        var req = await axios({
            method: 'GET',
            url: base_url + 'api/get',
            params: { data: JSON.stringify(data) },
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}

export async function post(url: string, data: any) {
    var formData = new FormData();
    for (var k in data) {
        formData.append(k, data[k]);
    }

    try {
        var req = await axios({
            method: 'POST',
            url: base_url + url,
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
        });

        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}

export async function postNew(url: string, data: any) {
    var formData = new FormData();
    for (var k in data) {
        formData.append(k, data[k]);
    }
    try {
        var req = await axios({
            method: 'POST',
            url: base_url + url,
            data: formData,
            headers: { 'Content-Type': 'application/json', },
        });
        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}

export async function jsonPost(data: any, url?: string) {
    try {
        var req = await axios({
            method: 'POST',
            url: base_url + (url ?? 'auth/any'),
            data: data,
        });
        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}

export async function authJsonPost(data: any, url?: string) {
    var creds = await getSavedUser();
    if (!creds?.token) return { code: 401, message: 'Unauthorized' };
    try {
        var req = await axios({
            method: 'POST',
            url: base_url + (url ?? 'auth/any'),
            data: data,
            headers: {
                'GEN-AUTH': creds.token,
            },
        });

        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}

export async function getAuth(path: string) {
    try {
        var creds = await getSavedUser();
        if (!creds?.token) return { code: 401, message: 'Unauthorized' };
        var req = await axios({
            method: 'GET',
            url: `${base_url}${path}`,
            headers: {
                'GEN-AUTH': creds.token,
            },
        });

        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}

export async function pubGet(url: string) {
    try {
        var req = await axios({
            method: 'GET',
            url: `${base_url}api/${url}`,
        });
        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}

export async function authJsonGet(data: any) {
    var creds = await getSavedUser();
    if (!creds?.token) return { code: 401, message: 'Unauthorized' };
    try {
        var req = await axios({
            method: 'GET',
            url: base_url + 'auth/any',
            params: { data: JSON.stringify(data) },
            headers: {
                'GEN-AUTH': creds.token,
                'Content-Type': 'application/json',
            },
        });
        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}

export async function authGet(url: string) {
    var creds = await getSavedUser();
    if (!creds?.token) return { code: 401, message: 'Unauthorized' };
    try {
        var req = await axios({
            method: 'GET',
            url: base_url + url,
            headers: {
                'GEN-AUTH': creds.token,
                'Content-Type': 'application/json',
            },
        });
        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}

export async function authJsonEdit(data: any) {
    var creds = await getSavedUser();
    if (!creds?.token) return { code: 401, message: 'Unauthorized' };
    try {
        var req = await axios({
            method: 'PUT',
            url: base_url + 'auth/any',
            data,
            headers: {
                'GEN-AUTH': creds.token,
                'Content-Type': 'application/json',
            },
        });
        return req.data;
    } catch (err) {
        console.log(err);

        return { code: 500 };
    }
}

export async function authPostEmpty(url: any) {
    var creds = await getSavedUser();
    if (!creds?.token) return { code: 401, message: 'Unauthorized' };
    try {
        var req = await axios({
            method: 'POST',
            url: `${base_url}${url}`,
            headers: {
                'GEN-AUTH': creds.token,
            },
        });
        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}


export async function getSavedUser() {
    const creds = getSecureItem(AUTH_CREDS_KEY);
    if (!creds) return null;
    if (creds.token && isTokenExpired(creds.token)) {
        clearAuthSession();
        return null;
    }
    return creds;
}

export async function upload(data: any) {
    var creds = await getSavedUser();
    if (!creds?.token) return { code: 401, message: 'Unauthorized' };
    var formData = new FormData();
    for (var k in data) {
        formData.append(k, data[k]);
    }
    try {
        var req = await axios({
            method: 'POST',
            url: `${base_url}auth/upload`,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
                'GEN-AUTH': creds.token,
            },
        });
        return req.data;
    } catch (err) {
        return { code: 500 };
    }
}